const readNamePart = (record: Record<string, unknown>, keys: string[]): string => {
  for (const key of keys) {
    const value = record[key];
    if (typeof value === 'string' && value.trim()) return value.trim();
  }
  return '';
};

/** Нормализует имя клиента из строки или объекта API (`first`/`last`, `firstName` и т.п.). */
export const formatClientName = (name: unknown): string => {
  if (typeof name === 'string' && name.trim()) return name.trim();
  if (!name || typeof name !== 'object') return '';

  const record = name as Record<string, unknown>;
  const first = readNamePart(record, ['first', 'firstName', 'first_name']);
  const last = readNamePart(record, ['last', 'lastName', 'last_name']);
  const fromParts = [last, first].filter(Boolean).join(' ').trim();
  if (fromParts) return fromParts;

  const nested = readNamePart(record, ['name', 'fullName', 'full_name', 'value']);
  if (nested) return nested;

  return Object.values(record)
    .filter((value): value is string => typeof value === 'string' && Boolean(value.trim()))
    .join(' ')
    .trim();
};

/**
 * Форматирует номер телефона по маске +7 (XXX) XXX-XX-XX
 */
export const formatPhoneWithMask = (phone: string): string => {
  const digits = phone.replace(/\D/g, '');
  if (!digits) return '+7 ';
  
  let result = '+7 ';
  const rest = digits.startsWith('7') ? digits.slice(1) : digits.startsWith('8') ? digits.slice(1) : digits;
  
  if (rest.length > 0) result += '(' + rest.slice(0, 3);
  if (rest.length >= 3) result += ') ';
  if (rest.length > 3) result += rest.slice(3, 6);
  if (rest.length >= 6) result += '-';
  if (rest.length > 6) result += rest.slice(6, 8);
  if (rest.length >= 8) result += '-';
  if (rest.length > 8) result += rest.slice(8, 10);
  
  return result;
};

/** Приводит телефон к E.164 для API: +79088888888. Возвращает null, если номер неполный. */
export const normalizePhoneToE164 = (phone: string): string | null => {
  const digits = phone.replace(/\D/g, '');

  if (digits.length === 11 && digits.startsWith('7')) {
    return `+${digits}`;
  }

  if (digits.length === 10) {
    return `+7${digits}`;
  }

  return null;
};

/** Проверяет, что в номере 10 цифр после кода страны */
export const isPhoneComplete = (phone: string): boolean => normalizePhoneToE164(phone) !== null;
